
class TD_HERO {
  constructor(element) {
    this.element = element;

    if(this.element.classList.contains('hero--rotator')) {
      this.initRotator();
    }
  }

  initRotator() {
    const slides = this.element.querySelectorAll('.hero__rotator-image');
    if(!slides.length || slides.length < 2) return; // No need to rotate if less than 2 slides

    let currentIndex = 0;
    const totalSlides = slides.length;

    slides.forEach((slide, index) => {
      if(index !== currentIndex) {
        slide.classList.remove('active');
      }
    }); 

    setInterval(() => {
      slides[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % totalSlides;
      slides[currentIndex].classList.add('active');
    }, 5000); // Change slide every 5 seconds
  }
}

export function initializeHero() {
  const heroElements = document.querySelectorAll('.hero');

  heroElements.forEach((element) => {
    new TD_HERO(element);
  });
}